import { LinkedDataType, LinkedRootDataType, linkSchema } from "./schema";

export const ledgerEntrySchema: LinkedRootDataType = linkSchema([
  {
    id: "price_component",
    plural: "Price Components",
    possessive: "Price Component's",
    singular: "Price Component",
    path: "price_components",
    idAttribute: null,
    properties: [],
  },
]);

const priceComponentDataType: LinkedDataType = {
  plural: "Price Components",
  possessive: "Price Component's",
  singular: "Price Component",
  path: "price_components",
  dataType: null,
  relations: [],
  manyRelations: [],
  id: "price_component",
  idAttribute: null,
  properties: [
    {
      name: "Amount",
      type: "currency_cents",
      via: "value",
      dataType: null,
    },
    {
      name: "Name",
      type: "string",
      via: "name",
      dataType: null,
    },
  ],
};
priceComponentDataType.dataType = priceComponentDataType;
priceComponentDataType.properties[0].dataType = priceComponentDataType;
priceComponentDataType.properties[1].dataType = priceComponentDataType;

ledgerEntrySchema.relations.push({
  id: "price_component",
  via: "price_components[0]",
  name: "Subtotal",
  dataType: priceComponentDataType,
});

ledgerEntrySchema.relations.push({
  id: "price_component",
  via: "price_components[1]",
  name: "GST",
  dataType: priceComponentDataType,
});

ledgerEntrySchema.properties = [
  {
    type: "string",
    via: "gl_code",
    name: "GL Code",
    dataType: ledgerEntrySchema,
  },
  {
    type: "string",
    via: "comment",
    name: "Comment",
    dataType: ledgerEntrySchema,
  },
  {
    type: "string",
    via: "category",
    name: "Category",
    dataType: ledgerEntrySchema,
  },
  {
    type: "business_id",
    via: "from_business",
    name: "From Business",
    dataType: ledgerEntrySchema,
  },
  {
    type: "business_id",
    via: "to_business",
    name: "To Business",
    dataType: ledgerEntrySchema,
  },
  {
    type: "string",
    via: "invoice_line_item",
    name: "Invoice Line Item",
    dataType: ledgerEntrySchema,
  },
  {
    type: "string",
    via: "item_id",
    name: "Item ID",
    dataType: ledgerEntrySchema,
  },
  {
    type: "string",
    via: "item_type",
    name: "Item Type",
    dataType: ledgerEntrySchema,
  },
  {
    name: "Unit Price",
    via: "price_cents",
    type: "currency_cents",
    dataType: ledgerEntrySchema,
  },
  {
    name: "Quantity",
    via: "quantity",
    type: "integer",
    dataType: ledgerEntrySchema,
  },
  {
    name: "Rule Name",
    via: "rule_name",
    type: "string",
    dataType: ledgerEntrySchema,
  },
  {
    name: "Tax Type",
    type: "tax_type",
    via: "tax_type",
    dataType: ledgerEntrySchema,
  },
  {
    name: "Title",
    via: "title",
    type: "string",
    dataType: ledgerEntrySchema,
  },
];

ledgerEntrySchema.plural = "Ledger Entries";
ledgerEntrySchema.possessive = "Ledger Entry's";
ledgerEntrySchema.singular = "Ledger Entry";
ledgerEntrySchema.idAttribute = "id";
ledgerEntrySchema.dataType = ledgerEntrySchema;
